/**
 * German weekday labels used by BlockedTimes day selector.
 * Array index + 1 corresponds to the backend `weekday` smallint (1..5).
 */
export const WEEK_DAYS = [
  "Montag",
  "Dienstag",
  "Mittwoch",
  "Donnerstag",
  "Freitag",
] as const;

export type WeekDayLabel = (typeof WEEK_DAYS)[number];

/** "Montag" → 1, "Freitag" → 5. Returns 1 for unknown input. */
export function weekDayLabelToInt(label: string | undefined | null): number {
  if (!label) return 1;
  const idx = WEEK_DAYS.indexOf(label as WeekDayLabel);
  return idx >= 0 ? idx + 1 : 1;
}

/** 1 → "Montag", 5 → "Freitag". Returns "Montag" for out-of-range input. */
export function intToWeekDayLabel(weekday: number | undefined | null): WeekDayLabel {
  if (!weekday || weekday < 1 || weekday > WEEK_DAYS.length) return "Montag";
  return WEEK_DAYS[weekday - 1];
}
